import React from 'react';
import { Header } from './components/Header';
import { HeroSection } from './components/HeroSection';
import { ServicesSection } from './components/ServicesSection';
import { WhyChooseUsSection } from './components/WhyChooseUsSection';
import { ProcessSection } from './components/ProcessSection';
import { CTASection } from './components/CTASection';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-gray-900 text-white" data-id="element-0">
      <Header data-id="element-1" />
      <main data-id="element-2">
        <HeroSection data-id="element-3" />
        <ServicesSection data-id="element-4" />
        <WhyChooseUsSection data-id="element-5" />
        <ProcessSection data-id="element-6" />
        <CTASection data-id="element-7" />
      </main>
      <Footer data-id="element-8" />
    </div>;
}